import { Font } from '@utmb/design-system/text/font';
import { roundToDistanceInKmDecimal } from '@utmb/utils/distance';
import { formatUnit } from '@utmb/utils/unit';
import type { ReactElement } from 'react';
import React from 'react';
import styles from '.././preregistration.module.scss';
import { RacePreregistrationOpenView } from '@utmb/types/index';
import { UnitEnum } from '@utmb/types/unit-enum';
import { useTranslation } from 'next-i18next';

interface StatsProps {
    prereg: RacePreregistrationOpenView;
    preferredUnit: UnitEnum;
}

export function Stats({ prereg, preferredUnit }: StatsProps): ReactElement {
    const { t } = useTranslation();
    return (
        <ul className={styles.stats}>
            <li className={styles.stats_item}>
                <Font.OxaniumRegular mobile="12" desktop="14" className={styles.stats_item_label}>
                    {t('races.keyfigures.startDate')}
                </Font.OxaniumRegular>
                <Font.OxaniumBold mobile="16" desktop="18" className={styles.stats_item_value}>
                    {prereg.date ?? '-'}
                </Font.OxaniumBold>
            </li>
            <li className={styles.stats_item}>
                <Font.OxaniumRegular mobile="12" desktop="14" className={styles.stats_item_label}>
                    {t('races.keyfigures.distance')}
                </Font.OxaniumRegular>
                <Font.OxaniumBold mobile="16" desktop="18" className={styles.stats_item_value}>
                    {formatUnit(preferredUnit, 'distance', roundToDistanceInKmDecimal(prereg.distance * 1000))}
                </Font.OxaniumBold>
            </li>
            <li className={styles.stats_item}>
                <Font.OxaniumRegular mobile="12" desktop="14" className={styles.stats_item_label}>
                    {t('races.keyfigures.elevationGain')}
                </Font.OxaniumRegular>
                <Font.OxaniumBold mobile="16" desktop="18" className={styles.stats_item_value}>
                    {formatUnit(preferredUnit, 'elevationGain', prereg.elevationGain)}
                </Font.OxaniumBold>
            </li>
        </ul>
    );
}
